import React from "react";
import { motion } from "framer-motion";
import { PiGraduationCapFill, PiBriefcaseFill } from "react-icons/pi";

const container = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      when: "beforeChildren",
      staggerChildren: 0.12,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const edu = [
  { period: "2023 – 2024", title: "UI/UX Design", place: "Ostad Limited" },
  {
    period: "2020 – 2023",
    title: "M.Sc in Applied Statistics & Data Science",
    place: "Jahangirnagar University",
  },
  {
    period: "2013 – 2017",
    title: "B.Sc in Computer Science & Engineering",
    place: "World University",
  },
];

const work = [
  {
    period: "2021 – 2025",
    title: " Full Stack Developer",
    place: "FRA Technology",
  },
  {
    period: "2024 – Present",
    title: "Full Stack AI Driven Developer",
    place: "Freelance",
  },
  {
    period: "2019 - Present",
    title: "Faculty of Computer Science",
    place: "Scholastica Ltd.",
  },
];

function Journey() {
  return (
    <section id="journey" className="py-14 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.3 }}
          className="flex items-center justify-center mb-8 sm:mb-10"
        >
          <motion.div variants={item} className="space-y-2 text-center">
            <p className="text-sm font-medium text-gray-500 flex items-center gap-2 justify-center">
              <span
                className="inline-block h-1.5 w-1.5 rounded-full"
                style={{ backgroundColor: "rgb(232, 51, 16)" }}
              />
              Education & Work
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold tracking-tight leading-tight">
              My <span style={{ color: "rgb(232, 51, 16)" }}>Academic and</span>{" "}
              Professional Journey
            </h2>
          </motion.div>
        </motion.div>

        {/* Two cards */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {/* Education */}
          <motion.div
            variants={item}
            className="rounded-3xl bg-gray-50 border border-gray-200 shadow-sm p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#211033] text-white">
                <PiGraduationCapFill />
              </span>
              <h3 className="text-xl font-extrabold text-gray-900">
                Education
              </h3>
            </div>
            <div className="divide-y divide-gray-200">
              {edu.map((e, i) => (
                <div key={i} className="py-4 flex gap-4">
                  <div className="w-24 shrink-0 text-xs font-semibold text-gray-500">
                    {e.period}
                  </div>
                  <div className="flex-1">
                    <div className="text-gray-900 font-extrabold">
                      {e.title}
                    </div>
                    <div className="text-gray-500 text-sm">{e.place}</div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Work Experience */}
          <motion.div
            variants={item}
            className="rounded-3xl bg-gray-50 border border-gray-200 shadow-sm p-6"
          >
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#211033] text-white">
                <PiBriefcaseFill />
              </span>
              <h3 className="text-xl font-extrabold text-gray-900">
                Work Experience
              </h3>
            </div>
            <div className="divide-y divide-gray-200">
              {work.map((w, i) => (
                <div key={i} className="py-4 flex gap-4">
                  <div className="w-24 shrink-0 text-xs font-semibold text-gray-500">
                    {w.period}
                  </div>
                  <div className="flex-1">
                    <div className="text-gray-900 font-extrabold">
                      {w.title}
                    </div>
                    <div className="text-gray-500 text-sm">{w.place}</div>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Journey;
